import { render } from "./FreeportLetter.vue?vue&type=template&id=447077ea"
import script from "./FreeportLetter.vue?vue&type=script&lang=js"
export * from "./FreeportLetter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__